import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyCompleted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M51.8691 31.7246C52.2619 31.4043 52.8409 31.4269 53.207 31.793C53.5731 32.1591 53.5957 32.7381 53.2754 33.1309L53.207 33.207L35.707 50.707C35.3165 51.0976 34.6835 51.0976 34.293 50.707L26.793 43.207L26.7246 43.1309C26.4043 42.7381 26.4268 42.1591 26.793 41.793C27.1591 41.4269 27.7381 41.4043 28.1309 41.7246L28.207 41.793L35 48.5859L51.793 31.793L51.8691 31.7246Z",
		fill: "#D0D0D2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M69 40C69 23.9837 56.0163 11 40 11C23.9837 11 11 23.9837 11 40C11 56.0163 23.9837 69 40 69C56.0163 69 69 56.0163 69 40ZM71 40C71 57.1208 57.1208 71 40 71C22.8792 71 9 57.1208 9 40C9 22.8792 22.8792 9 40 9C57.1208 9 71 22.8792 71 40Z",
		fill: "#D0D0D2"
	})]
});
export default SvgEmptyCompleted;
